var _a;
export const UNBXD = {
    endpoint: process.env.UNBXD_ENDPOINT || 'https://search.unbxd.io',
    siteKey: process.env.UNBXD_SITE_KEY || '',
    apiKey: process.env.UNBXD_API_KEY || ''
};
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';
// ---------------------------------------------------------------------------
// Central application config – single source of truth
// ---------------------------------------------------------------------------
export const AppConfig = {
    /** Which search backend to use – falls back to using mock data */
    provider: ((_a = process.env.PROVIDER) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || 'mock',
    /** File in /mock/ folder to load when useMock === true */
    mockFile: process.env.MOCK_FILE || 'sample-search.json',
    /** How UI state is pushed to the URL */
    routing: 'query-param',
    /** Default storefront query when the page first loads */
    defaultQuery: '*',
    /** Pagination defaults */
    page: {
        defaultSize: 24,
        mobileSize: 12,
        maxSize: 48
    },
    /** Show a search bar */
    showSearchBar: false,
    /** Per‑provider secrets / endpoints */
    searchSettings: {
        unbxd: {
            apiUrl: `${UNBXD.endpoint}/${UNBXD.apiKey}/${UNBXD.siteKey}`
        },
        algolia: {
            appId: process.env.ALGOLIA_APP_ID || '',
            apiKey: process.env.ALGOLIA_API_KEY || '',
            indexName: process.env.ALGOLIA_INDEX || ''
        },
        boost: {
            apiUrl: process.env.BOOST_API_URL || '',
            shop: process.env.BOOST_SHOP_URL || '',
        }
    }
};
export default AppConfig;
